import React, { useState } from 'react';
import { createUserWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { auth, db } from '../../firebaseConfig';
import { doc, setDoc } from 'firebase/firestore';

const Register = ({ setUser, setShowLogin, setShowRegister, setAckMessage }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleEmailRegister = async (e) => {
        e.preventDefault();
        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
            await setDoc(doc(db, 'users', user.uid), {
                email: user.email,
                cart: [],
                interests: [],
            });
            setUser(user);
            setShowRegister(false);
            setAckMessage('Registration successful!');
            setTimeout(() => setAckMessage(null), 3000);
        } catch (error) {
            console.error('Error registering:', error);
        }
    };

    const handleGoogleRegister = async () => {
        const provider = new GoogleAuthProvider();
        try {
            const userCredential = await signInWithPopup(auth, provider);
            const user = userCredential.user;
            await setDoc(doc(db, 'users', user.uid), {
                email: user.email,
                cart: [],
                interests: [],
            });
            setUser(user);
            setShowRegister(false);
            setAckMessage('Registration successful!');
            setTimeout(() => setAckMessage(null), 3000);
        } catch (error) {
            console.error('Error registering with Google:', error);
        }
    };

    return (
        <div>
            <form onSubmit={handleEmailRegister}>
                <h2>Email Register</h2>
                <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email</label>
                    <input type="email" className="form-control" id="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                </div>
                <div className="mb-3">
                    <label htmlFor="password" className="form-label">Password</label>
                    <input className="form-control" id="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                </div>
                <button type="submit" className="btn btn-primary">Register</button>
            </form>
            <button className="btn btn-danger mt-3" onClick={handleGoogleRegister}>Register with Google</button>
            <button type="button" className="btn btn-link mt-3" onClick={() => { setShowRegister(false); setShowLogin(true); }}>Login</button>
        </div>
    );
};

export default Register;